import React from 'react';
import type { PlaylistItem } from '@jwp/ott-common/types/playlist';

import TruncatedText from '../TruncatedText/TruncatedText';

import styles from './MediaDescription.module.scss';

const MediaDescription = ({ item, maxLines = 2 }: { item: PlaylistItem; maxLines?: number }) => {
  return <>{item.synopsis ? (item.synopsis as string) : <TruncatedText text={item.description} maximumLines={maxLines} className={styles.description} />}</>;
};

export default MediaDescription;
